import { render } from "./contestantIndex.vue?vue&type=template&id=1b6785bc&scoped=true"
import script from "./contestantIndex.vue?vue&type=script&lang=js"
export * from "./contestantIndex.vue?vue&type=script&lang=js"

import "@/css/view.css?vue&type=style&index=0&id=1b6785bc&scoped=true&lang=css"
import "@/css/information.css?vue&type=style&index=1&id=1b6785bc&scoped=true&lang=css"
import "./contestantIndex.vue?vue&type=style&index=2&id=1b6785bc&scoped=true&lang=css"
import "./contestantIndex.vue?vue&type=style&index=3&id=1b6785bc&lang=css"

import exportComponent from "C:\\Users\\Mr.Wu\\Desktop\\Files\\XiHe\\code\\xihe_levelexam_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b6785bc"]])

export default __exports__